import { BigNum } from '@drift-labs/sdk';
import BottomDrawer from 'src/components/Drawers/BaseDrawers/BottomDrawer/BottomDrawer';
import useCloseBottomDrawer from 'src/components/Drawers/BaseDrawers/BottomDrawer/hooks/useCloseBottomDrawer';
import Button from 'src/components/primitives/Button/Button';

interface Props {
	onClose: () => void;
	entryPrice: BigNum;
	markPrice: BigNum;
}

export default function MarkPriceChangeBottomDrawer({
	onClose,
	entryPrice,
	markPrice,
}: Props) {
	const { closeDrawer, isDrawerClosing } = useCloseBottomDrawer({
		onClose,
	});

	const percentChange =
		((markPrice.toNum() - entryPrice.toNum()) / entryPrice.toNum()) * 100;

	const isHigher = percentChange >= 0;
	const absPercent = Math.abs(percentChange);

	return (
		<BottomDrawer.Container
			closeDrawer={closeDrawer}
			isDrawerClosing={isDrawerClosing}
		>
			<BottomDrawer.Title closeDrawer={closeDrawer}>
				Asset Price Change
			</BottomDrawer.Title>
			<BottomDrawer.Body>
				Mark Price is {absPercent.toFixed(2)}% {isHigher ? 'higher' : 'lower'}{' '}
				than the Entry Price
			</BottomDrawer.Body>
			<BottomDrawer.Footer>
				<Button
					size="lg"
					variant="secondary"
					className="w-full"
					onClick={closeDrawer}
				>
					Close
				</Button>
			</BottomDrawer.Footer>
		</BottomDrawer.Container>
	);
}
